const FOCAVEIS = 'button:not([disabled]), input:not([disabled]), select:not([disabled]), [href], [tabindex]:not([tabindex="-1"])';

/** `aria-modal` não prende o Tab sozinho: do último volta ao primeiro, e vice-versa. */
export function prenderFoco(janela: HTMLElement, evento: KeyboardEvent) {
    const focaveis = Array.from(janela.querySelectorAll<HTMLElement>(FOCAVEIS));
    if (focaveis.length === 0) return;
    const primeiro = focaveis[0];
    const ultimo = focaveis[focaveis.length - 1];
    const ativo = document.activeElement;
    const dentro = ativo instanceof Node && janela.contains(ativo) && ativo !== janela;
    if (evento.shiftKey && (!dentro || ativo === primeiro)) {
        evento.preventDefault();
        ultimo.focus();
    } else if (!evento.shiftKey && (!dentro || ativo === ultimo)) {
        evento.preventDefault();
        primeiro.focus();
    }
}
